<script>
import Vue from 'vue'
import { getAll, get, edit, PREFIX } from '@/api'
import { groupBy, groupFlat } from '@/utils'
export default {
  watch: {
    'items.users' () {
      if (this.items.users.length > 0 && !this.id && !(this.item && this.item.from_template)) { // new task and no from template
        this.getDefaultAssignation()
      }
    }
  },
  computed: {
    required_rules () {
      return this.item.is_template ? '' : 'required'
    }
  },
  methods: {
    checkThisOut () {
      this.$store.dispatch('SET_CHECK_THIS_OUT', { url: this.urlObj, id: this.item.id }).then((response) => {
        this.item.check_this_persons = response.data
        // this.$store.dispatch('SET_COUNTERS').then(() => {}).catch(err => {})
      }).catch(err => {})
    },
    load () {
      this.$store.commit('SET_LOADING', true)
      get(this.urlObj, this.item.id).then((response) => {
        this.item = response.data
        // check watch this
        setTimeout(() => {
          this.checkThisOut()
        }, 100)

        // breadcrumb
        this.setBreadcrumb()
        this.externalInit()
        this.$store.commit('SET_LOADING', false)
      }).catch((err) => {
        this.$store.commit('SET_LOADING', false)
        this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка!', type: 'error' })
      })
    },
    loadTemplates () {
      getAll(this.urlList + 'templates/').then((response) => {
        this.templates = response.data.results
      }).catch((err) => {
        this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка загрузки шаблонов!', type: 'error' })
      })
    },
    getDefaultAssignation () {
      getAll(this.urlList + 'assignation/').then((response) => {
        delete response.data.id
        const lst = response.data
        for (const [key, values] of Object.entries(lst)) {
          // console.log(`${key}: ${values}`)
          Vue.set(this.item, key, values)
        }

      }).catch((err) => {
        this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка дефолтных ролей!', type: 'error' })
      })
    },
    externalInit () {
      this.loadTemplates()
    },
    changeStatus (value) {
      this.pendingStatus = true
      this.$store.commit('SET_LOADING', true)
      edit(this.urlObj, this.item.id, { status: value }, 'status/').then((response) => {
        this.item = response.data
        this.pendingStatus = false
        this.$store.commit('SET_LOADING', false)
        this.$notify({ group: 'main', title: 'Статус', text: 'Успешно!', type: 'success' })
      }).catch((err) => {
        console.log('ERRR', err.response)
        this.pendingStatus = false
        if (err.response && err.response.data && err.response.data.status) {
          this.$notify({ group: 'main', title: 'Статус', text: 'Ошибка! ' + err.response.data.status, type: 'warning' })
        } else {
          this.$notify({ group: 'main', title: 'Статус', text: 'Ошибка! ' + err.response.status + ' ' + err.response.statusText, type: 'error' })
        }
        this.$store.commit('SET_LOADING', false)
      })
    },
    // removeFromMultiple (item, lst) {
    //   const obj = lst.filter(i => {
    //     return i.id === item.id
    //   })

    //   const index = lst.indexOf(obj[0])
    //   if (index >= 0) lst.splice(index, 1)
    // },
    addToTags (value) {
      this.item.tags_lst = value
    }
  }
}
</script>
